import isIpad from './isIpad'
import isMobile from './isMobile'

export default function shouldBehaveAsMobile(orientation: 'landscape' | 'portrait') {
    const isMobileDevice = isMobile()

    const isDeviceIpad = isIpad() && orientation === 'portrait'

    return isMobileDevice || isDeviceIpad
}
